module.exports = __webpack_public_path__ + "img/logo.87343ed6.png";